import { Box } from "@mui/system";
import CircleIcon from "@mui/icons-material/Circle";

const iconColors = ["success", "error", "warning", "info", "disabled", "action", "primary", "secondary", "inherit"] as const;

type IconColor = typeof iconColors[number];

export type StatusColor = IconColor | (string & {});

interface StatusLabelProps {
    label: string
    color: StatusColor
    title?: string
}

export default function StatusLabel(props: StatusLabelProps) {
    const isIconColor = (iconColors as readonly string[]).includes(props.color);

    return <Box className="status-label" title={props.title} sx={{
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
    }}>
        <CircleIcon
            fontSize="small"
            color={isIconColor ? props.color as IconColor : undefined}
            sx={{ transform: "scale(0.6)", ...(isIconColor ? {} : { color: props.color }) }}
        />
        <span>{props.label}</span>
    </Box>;
}
